import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { SendSmsPayload } from '../types';
import { LEAD_DETAILS } from './constants';

const useSendSms = (onSuccess?: () => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: SendSmsPayload }) => {
        const { lead_id, sms_type, message_body } = payload;
        return req({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/leads/${lead_id}/send-sms/`,
            method: 'POST',
            body: JSON.stringify({
                sms_type,
                ...(sms_type === 'free_form' && message_body ? { message_body } : {})
            })
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [LEAD_DETAILS] });
            setNotification({ message: 'SMS sent' });
            onSuccess && onSuccess();
        },
        onError: (error: { errors: string[] }) => {
            return error;
        }
    });
};

export default useSendSms;
